var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIncidents = function SvgIncidents(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 50,
    height: 50,
    rx: 25,
    fill: "url(#incidents_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 20.75V26M16.42 21.58c0-1.12.6-2.16 1.57-2.73l5.94-3.43c.97-.56 2.17-.56 3.15 0l5.94 3.43c.97.56 1.57 1.6 1.57 2.73v6.84c0 1.12-.6 2.16-1.57 2.73l-5.94 3.43c-.97.56-2.17.56-3.15 0l-5.94-3.43a3.15 3.15 0 0 1-1.57-2.73v-2.76",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 29.2v.1",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "incidents_svg__a",
    x1: 25.5,
    y1: 0,
    x2: 25.5,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C68F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#4C68F6",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C68F6",
    stopOpacity: 0.49
  })))));
};
export default SvgIncidents;